import { redirect } from '@tanstack/react-router'

import { isEnvelopeStatusFilter } from '@/api/v1/ecm/envelopes'
import { envelopesStatusPath } from '@/lib/envelopes-path'

export function redirectToEnvelopesStatus({
  search,
}: {
  search: object
}): never {
  const entries = Object.entries(search)
  const status: unknown = entries.find(([key]) => key === 'status')?.[1]
  throw redirect({
    to: envelopesStatusPath(isEnvelopeStatusFilter(status) ? status : 'all'),
    search: Object.fromEntries(entries.filter(([key]) => key !== 'status')),
    replace: true,
  })
}
